import React, { useEffect, useState } from 'react';
import FormTitle from 'components/atoms/Form/FormTitle';
import FormField from 'components/atoms/Form/FormField';
import RadioSelectForm from 'components/molecules/RadioSelectForm';
import FormContents from 'components/atoms/Form/FormContents';
import FlexBox from 'components/atoms/FlexBox';
import HourInput from 'components/atoms/Form/HourInput';
import FormLabel from 'components/atoms/Form/FormLabel';
import VerticalLabelFormLayout from 'components/atoms/Form/VerticalLabelFormLayout';
import BodyText from 'components/atoms/BodyText';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import FormLayout from 'components/atoms/Form/VerticalLabelFormLayout';
import { gridCol, grayScale } from 'components/styles';
import VerticalLabelSelectForm from 'components/molecules/VerticalLabelSelectForm';
import { OptionType } from 'components/atoms/Select';
import { css, jsx } from '@emotion/core';

const listHours = [
  '00', '01', '02', '03', '04', '05', '06', '07', '08', '09',
  '10', '11', '12', '13', '14', '15', '16', '17', '18', '19',
  '20', '21', '22', '23',
];
const listTimes = [
  '00', '01', '02', '03', '04', '05', '06', '07', '08', '09',
  '10', '11', '12', '13', '14', '15', '16', '17', '18', '19',
  '20', '21', '22', '23', '24', '25', '26', '27', '28', '29',
  '30', '31', '32', '33', '34', '35', '36', '37', '38', '39',
  '40', '41', '42', '43', '44', '45', '46', '47', '48', '49',
  '50', '51', '52', '53', '54', '55', '56', '57', '58', '59',
];

const styles = {
  help: css({
    color: 'red',
    bottom: '-13px',
    left: '10px',
    position: 'relative'
  }),
  span: css({
    margin: '0px 10px',
    position: 'relative',
    top: '-2px'
  }),
  addon: css({
    color: grayScale.gray100,
    padding: '7px'
  }),
  formBody: css({
    padding: '5px 40px',
    margin: '0px',
    paddingBottom: '30px'
  }),
  formHeader: css({
    margin: '16px 0px'
  }),
  formDate: css({
    margin: 'none',
    padding: '0px 20px',
    marginTop: '10px'
  }),
  formFieldDate: css({
    marginTop: '-25px'
  })
}

const TakeCareRelativeForm: React.FC<{
  paidCalculationStandard: boolean,
  setPaidCalculationStandard: any,
  isWorkTime: number,
  setIsWorkTime: any,
  yearUseDays: number,
  setYearUseDays: any,
  unUsableOfHalfHoliday: boolean,
  setUnUsableOfHalfHoliday: any,
  unUsableOfTimeHoliday: boolean,
  setUnUsableOfTimeHoliday: any,
  unUsableOfEntring6months: boolean,
  setUnUsableOfEntring6months: any,
  unUsableOfTrialPeriod: boolean,
  setUnUsableOfTrialPeriod: any,
  useEmploymentDeemedWorkingHours?: boolean,
  setUseEmploymentDeemedWorkingHours?: any
}> = ({
  paidCalculationStandard,
  setPaidCalculationStandard,
  isWorkTime,
  setIsWorkTime,
  yearUseDays,
  setYearUseDays,
  unUsableOfHalfHoliday,
  setUnUsableOfHalfHoliday,
  unUsableOfTimeHoliday,
  setUnUsableOfTimeHoliday,
  unUsableOfEntring6months,
  setUnUsableOfEntring6months,
  unUsableOfTrialPeriod,
  setUnUsableOfTrialPeriod,
  useEmploymentDeemedWorkingHours,
  setUseEmploymentDeemedWorkingHours
}) => {
    const [hourFormOptions, setHourFormOptions] = useState<Array<OptionType>>([]);
    const [timeFormOptions, setTimeFormOptions] = useState<Array<OptionType>>([]);
    const [contractWorkHourDayHours, setContractWorkHourDayHours] = useState<any>('00');
    const [contractWorkHourDayMinutes, setContractWorkHourDayMinutes] = useState<any>('00');

    useEffect(() => {
      setHourFormOptions(listHours.map((Hours) => ({
        value: Hours,
        label: Hours,
      })));
      setTimeFormOptions(listTimes.map((Hours: any) => ({
        value: Hours,
        label: Hours,
      })));
    }, []);

    return (
      <FormContents isSubForm={true} customStyle={styles.formBody}>
        <FormTitle
          title="介護休暇詳細設定"
          note=""
          customStyle={styles.formHeader}
        />
        <FormField>
          <RadioSelectForm
            label="有給算出基準：勤務日数への加算"
            subLabel=""
            items={[
              {
                label: '加算しない',
                value: '0',
              },
              {
                label: '加算する',
                value: '1',
              },
            ]}
            name="paidCalculationStandard"
            value={paidCalculationStandard ? '1' : '0'}
            setValue={(e) => {
              setPaidCalculationStandard(Boolean(e.target.value !== '0'));
            }}
          />
        </FormField>
        {/* <FormField>
          <RadioSelectForm
            label="みなし時間"
            subLabel=""
            items={[
              {
                label: '設定する',
                value: '0',
              },
              {
                label: '雇用形態に設定されている日の契約労働時間をみなし勤務時間とする',
                value: '1',
              },
            ]}
            name="useEmploymentDeemedWorkingHours"
            value={useEmploymentDeemedWorkingHours ? '1' : '0'}
            setValue={(e) => {
              setUseEmploymentDeemedWorkingHours(Boolean(e.target.value !== '0'));
            }}
          />
        </FormField>
        {useEmploymentDeemedWorkingHours === false && (
          <FormContents customStyle={styles.formDate}>
            <FormField displayBlock={true} customStyle={styles.formFieldDate}>
              <div style={{ marginRight: '12px', width: gridCol.grid06 }}>
                <FormLayout
                  label={() => {}}
                  input={(
                    <FlexBox>
                      <FlexBoxItem width="70px">
                        <VerticalLabelSelectForm
                          label=""
                          name="contractWorkHourDayHours"
                          value={String(contractWorkHourDayHours)}
                          setValue={(val: string) => {
                            setContractWorkHourDayHours(val);
                            // formik.setFieldValue('contractWorkHourDay', parseInt(contractWorkHourDayHours)*60 + parseInt(contractWorkHourDayMinutes));
                          }}
                          options={hourFormOptions}
                        />
                      </FlexBoxItem>
                      <BodyText customStyle={styles.addon}>時間</BodyText>
                      <FlexBoxItem width="70px">
                        <VerticalLabelSelectForm
                          label=""
                          name="contractWorkHourDayMinutes"
                          value={String(contractWorkHourDayMinutes)}
                          setValue={(val: string) => {
                            setContractWorkHourDayMinutes(val);
                            // formik.setFieldValue('contractWorkHourDay', parseInt(contractWorkHourDayHours)*60 + parseInt(contractWorkHourDayMinutes));
                          }}
                          options={timeFormOptions}
                        />
                      </FlexBoxItem>
                      <BodyText customStyle={styles.addon}>分</BodyText>
                    </FlexBox>
                  )}
                />
              </div>
            </FormField>
          </FormContents>
        )} */}

        <FormField>
          <RadioSelectForm
            label="みなし時間を労働時間に"
            subLabel=""
            items={[
              {
                label: '含まない',
                value: '0',
              },
              {
                label: '含む',
                value: '1',
              },
            ]}
            name="isWorkTime"
            value={isWorkTime ? '1' : '0'}
            setValue={(e) => {
              setIsWorkTime(Number(e.target.value !== '0'));
            }}
          />
        </FormField>
        <FormField>
          <RadioSelectForm
            label="年間取得日数"
            subLabel=""
            items={[
              {
                label: '無制限',
                value: '0',
              },
              {
                label: '日数を管理',
                value: '1',
              },
            ]}
            name="yearUseDays"
            value={yearUseDays ? '1' : '0'}
            setValue={(e) => {
              setYearUseDays(Number(e.target.value !== '0'));
            }}
          />
        </FormField>
        <FormField>
          <RadioSelectForm
            label="半休の使用可否"
            subLabel=""
            items={[
              {
                label: '使用不可',
                value: '0',
              },
              {
                label: '使用可',
                value: '1',
              },
            ]}
            name="unUsableOfHalfHoliday"
            value={unUsableOfHalfHoliday ? '1' : '0'}
            setValue={(e) => {
              setUnUsableOfHalfHoliday(Boolean(e.target.value !== '0'));
            }}
          />
        </FormField>
        <FormField>
          <RadioSelectForm
            label="時間単位の休暇の使用可否"
            subLabel=""
            items={[
              {
                label: '使用不可',
                value: '0',
              },
              {
                label: '使用可',
                value: '1',
              },
            ]}
            name="unUsableOfTimeHoliday"
            value={unUsableOfTimeHoliday ? '1' : '0'}
            setValue={(e) => {
              setUnUsableOfTimeHoliday(Boolean(e.target.value !== '0'));
            }}
          />
        </FormField>
        <FormField>
          <RadioSelectForm
            label="入社半年未満の使用可否"
            subLabel=""
            items={[
              {
                label: '使用不可',
                value: '0',
              },
              {
                label: '使用可',
                value: '1',
              },
            ]}
            name="unUsableOfEntring6months"
            value={unUsableOfEntring6months ? '1' : '0'}
            setValue={(e) => {
              setUnUsableOfEntring6months(Boolean(e.target.value !== '0'));
            }}
          />
        </FormField>
        <FormField>
          <RadioSelectForm
            label="試用期間中の使用可否"
            subLabel=""
            items={[
              {
                label: '使用不可',
                value: '1',
              },
              {
                label: '使用可',
                value: '0',
              },
            ]}
            name="unUsableOfTrialPeriod"
            value={unUsableOfTrialPeriod ? '1' : '0'}
            setValue={(e) => {
              setUnUsableOfTrialPeriod(Boolean(e.target.value !== '0'));
            }}
          />
        </FormField>
      </FormContents>
    );
  }
export default TakeCareRelativeForm;
